<div class="digital-card-page">
  <div class="card-container">
    
    <!-- ══════════════ LOADING SKELETON ══════════════ -->
    <div *ngIf="isLoading" class="skeleton-wrapper">
      <div class="skeleton-hero"></div>
      <div class="skeleton-mascot-card"></div>
      <div class="skeleton-tabs">
        <div class="skeleton-tab"></div>
        <div class="skeleton-tab"></div>
        <div class="skeleton-tab"></div>
        <div class="skeleton-tab"></div>
      </div>
      <div class="skeleton-body-card"></div>
    </div>

    <!-- ══════════════ ERROR / NOT FOUND STATE ══════════════ -->
    <div *ngIf="!isLoading && errorMessage" class="error-state-card">
      <div class="error-icon-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h2 class="error-title">Data Kamar Tidak Ditemukan</h2>
      <p class="error-desc">{{ errorMessage }}</p>
      <div class="error-actions">
        <button class="btn-refresh" (click)="loadCardData()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
            <path d="M21 3v5h-5"></path>
            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
            <path d="M8 16H3v5"></path>
          </svg>
          Coba Muat Ulang
        </button>
      </div>
    </div>

    <!-- ══════════════ MAIN CONTENT: PUBLIC DIGITAL ROOM CARD ══════════════ -->
    <div *ngIf="!isLoading && !errorMessage && cardData" class="main-content-flow">

      <!-- SIGNATURE KOSSAYA HERO HEADER -->
      <div class="kossaya-hero">
        <!-- Left darker accent strip with room number -->
        <div class="kossaya-hero__left-strip">
          <span class="kossaya-hero__room-number" [class.long]="cardData.room.label.length > 3">
            {{ cardData.room.label }}
          </span>
        </div>

        <!-- Main hero content area with watermark backdrop -->
        <div class="kossaya-hero__content">
          <img src="assets/images/kossaya/logo_backdrop.png" alt="" class="kossaya-hero__watermark" />
          
          <div class="hero-header-badge">
            <span class="status-dot"></span>
            {{ roomStatusLabel }}
          </div>

          <h1 class="hero-property-name">{{ cardData.property?.name || cardData.tenant.name }}</h1>
          
          <div class="hero-room-meta">
            <span class="meta-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              {{ cardData.room.floor?.label || 'Lantai 1' }}
            </span>
            <span class="meta-dot">•</span>
            <span class="meta-item">{{ cardData.room.type?.name || 'Standard Room' }}</span>
          </div>
        </div>
      </div>

      <!-- VACANT ROOM SHOWCASE (WITH KOSSAYA MASCOT) -->
      <section class="vacant-showcase-card">
        <div class="vacant-card-content">
          <div class="vacant-text-wrap">
            <div class="pill-vacant">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span>Kamar Siap Huni</span>
            </div>
            <h2 class="vacant-title">Kamar {{ cardData.room.label }} Tersedia</h2>
            <p class="vacant-sub">Unit bersih, siap ditempati segera dengan fasilitas lengkap.</p>
            
            <div class="price-highlight-box" *ngIf="cardData.room.product && cardData.room.product.price > 0">
              <span class="price-label">Tarif Sewa Mulai</span>
              <div class="price-value-wrap">
                <span class="price-amount">{{ cardData.room.product.formatted_price }}</span>
                <span class="price-period">/ {{ cardData.room.product.duration_label || formatUnitDuration(cardData.room.product.periode) }}</span>
              </div>
            </div>

            <div class="price-highlight-box" *ngIf="cardData.room.prices.length > 0 && (!cardData.room.product || cardData.room.product.price === 0)">
              <span class="price-label">Mulai Dari</span>
              <div class="price-value-wrap">
                <span class="price-amount">{{ cardData.room.prices[0].formatted_price }}</span>
                <span class="price-period">/ {{ cardData.room.prices[0].duration_label || formatUnitDuration(cardData.room.prices[0].unit) }}</span>
              </div>
            </div>
          </div>

          <div class="mascot-img-wrap">
            <img src="assets/images/kossaya/byul_kamar_kosong.png" alt="Kos Saya Mascot" class="mascot-vacant" />
          </div>
        </div>

        <!-- QUICK WHATSAPP CTA BUTTON -->
        <div class="vacant-cta-row">
          <button class="btn-whatsapp-cta" (click)="openWhatsApp('6281234567890')">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.771-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.275.072.376-.044c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564c.173.087.289.129.332.202.043.073.043.419-.101.824z"/>
              <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2.05 21.95l4.922-1.342C8.423 21.493 10.153 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18c-1.71 0-3.308-.474-4.673-1.296l-.335-.201-2.907.794.806-2.835-.221-.352C3.791 14.743 3.333 13.411 3.333 12c0-4.779 3.888-8.667 8.667-8.667 4.778 0 8.667 3.888 8.667 8.667 0 4.779-3.889 8.667-8.667 8.667z"/>
            </svg>
            <span>Tanya / Reservasi Kamar</span>
          </button>
        </div>
      </section>

      <!-- NAVIGATION TABS -->
      <nav class="kossaya-tabs-nav">
        <button class="tab-btn" [class.active]="activeTab === 'overview'" (click)="activeTab = 'overview'">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
          <span>Fasilitas</span>
        </button>

        <button class="tab-btn" [class.active]="activeTab === 'prices'" (click)="activeTab = 'prices'">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="1" x2="12" y2="23"></line>
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
          </svg>
          <span>Tarif Sewa</span>
        </button>

        <button class="tab-btn" [class.active]="activeTab === 'location'" (click)="activeTab = 'location'">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span>Lokasi</span>
        </button>

        <button class="tab-btn" [class.active]="activeTab === 'history'" (click)="activeTab = 'history'" *ngIf="cardData.contract_history.length > 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 14 14"></polyline>
          </svg>
          <span>Riwayat</span>
        </button>
      </nav>

      <!-- TAB PANEL 1: FASILITAS & SPESIFIKASI -->
      <div *ngIf="activeTab === 'overview'" class="tab-pane-card">
        <!-- Spesifikasi Grid -->
        <div class="section-block">
          <h3 class="section-title">Spesifikasi Unit</h3>
          <div class="specs-grid">
            <div class="spec-card">
              <span class="spec-label">Nomor Unit</span>
              <span class="spec-value">Kamar {{ cardData.room.label }}</span>
            </div>
            <div class="spec-card">
              <span class="spec-label">Posisi Lantai</span>
              <span class="spec-value">{{ cardData.room.floor?.label || 'Lantai 1' }}</span>
            </div>
            <div class="spec-card">
              <span class="spec-label">Tipe Kamar</span>
              <span class="spec-value">{{ cardData.room.type?.name || 'Standard' }}</span>
            </div>
            <div class="spec-card">
              <span class="spec-label">Status Unit</span>
              <span class="spec-value text-available">Tersedia</span>
            </div>
          </div>
        </div>

        <!-- Fasilitas Bersama / Kamar -->
        <div class="section-block" *ngIf="cardData.room.facilities.length > 0">
          <h3 class="section-title">Fasilitas Termasuk</h3>
          <div *ngFor="let cat of facilityCategoryKeys" class="facility-category">
            <h4 class="facility-cat-name">{{ cat }}</h4>
            <div class="facility-pill-grid">
              <div *ngFor="let f of facilitiesByCategory[cat]" class="facility-pill">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2B7A78" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <span>{{ f.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="section-block" *ngIf="cardData.room.facilities.length === 0">
          <div class="empty-notice">
            <p>Fasilitas standar hunian kos telah tersedia pada unit ini.</p>
          </div>
        </div>
      </div>

      <!-- TAB PANEL 2: TARIF & PAKET SEWA -->
      <div *ngIf="activeTab === 'prices'" class="tab-pane-card">
        <h3 class="section-title">Daftar Paket & Tarif Sewa</h3>

        <div *ngIf="cardData.room.prices.length === 0 && !cardData.room.product" class="empty-notice">
          <p>Silakan hubungi pengelola kos untuk informasi paket harga sewa terkini.</p>
        </div>

        <div class="pricing-list-grid">
          <div *ngFor="let p of cardData.room.prices" class="pricing-item-card">
            <div class="pricing-header">
              <span class="pricing-duration-badge">{{ p.duration_label || (p.duration + ' ' + formatUnitDuration(p.unit)) }}</span>
              <span class="pricing-price-text">{{ p.formatted_price }}</span>
            </div>
            <p class="pricing-desc">Paket sewa per {{ p.duration_label || (p.duration + ' ' + formatUnitDuration(p.unit)) }} sudah termasuk akses fasilitas standar.</p>
          </div>

          <!-- Fallback Product Price -->
          <div *ngIf="cardData.room.prices.length === 0 && cardData.room.product" class="pricing-item-card">
            <div class="pricing-header">
              <span class="pricing-duration-badge">{{ cardData.room.product.duration_label || formatUnitDuration(cardData.room.product.periode) }}</span>
              <span class="pricing-price-text">{{ cardData.room.product.formatted_price }}</span>
            </div>
            <p class="pricing-desc">Tarif sewa reguler {{ cardData.room.product.name }}.</p>
          </div>
        </div>
      </div>

      <!-- TAB PANEL 3: LOKASI PROPERTI -->
      <div *ngIf="activeTab === 'location'" class="tab-pane-card">
        <h3 class="section-title">Lokasi & Alamat Kos</h3>

        <div class="location-details-box">
          <div class="loc-item">
            <span class="loc-lbl">Nama Kos / Properti</span>
            <span class="loc-val">{{ cardData.property?.name || cardData.tenant.name }}</span>
          </div>
          <div class="loc-item">
            <span class="loc-lbl">Alamat Lengkap</span>
            <span class="loc-val">{{ cardData.property?.address || '-' }}</span>
          </div>
          <div class="loc-item" *ngIf="cardData.property?.regency">
            <span class="loc-lbl">Kabupaten / Kota</span>
            <span class="loc-val">{{ cardData.property?.regency }}</span>
          </div>
          <div class="loc-item" *ngIf="cardData.property?.province">
            <span class="loc-lbl">Provinsi</span>
            <span class="loc-val">{{ cardData.property?.province }}</span>
          </div>
        </div>

        <div class="location-action-wrap">
          <button class="btn-open-maps" (click)="openMaps()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"></polygon>
              <line x1="9" y1="3" x2="9" y2="18"></line>
              <line x1="15" y1="6" x2="15" y2="21"></line>
            </svg>
            <span>Petunjuk Arah Google Maps</span>
          </button>
        </div>
      </div>

      <!-- TAB PANEL 4: RIWAYAT KONTRAK -->
      <div *ngIf="activeTab === 'history'" class="tab-pane-card">
        <h3 class="section-title">Riwayat Kontrak Kamar</h3>

        <div class="history-timeline">
          <div *ngFor="let h of cardData.contract_history" class="history-item">
            <div class="history-dot"></div>
            <div class="history-card">
              <div class="history-top">
                <span class="history-name">{{ h.occupant_name }}</span>
                <span class="history-price">{{ h.formatted_total_price }}</span>
              </div>
              <div class="history-dates">
                <span>{{ formatDate(h.start_date) }} — {{ formatDate(h.end_date) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <footer class="kossaya-public-footer">
        <img src="assets/images/kossaya/logo.png" alt="Kos Saya" class="footer-logo" />
        <p class="footer-tagline">Kelola Kosan Lebih Mudah dengan <strong>Kossaya</strong></p>
      </footer>

    </div>
  </div>
</div>
